<template>
	<header class="head-menu" :class="{open: openMenu}">
		<div class="logo" @click.stop="openPage('/index')">
			<img :src="logoImg" alt="">
		</div>
		<nav class="menu">
			<template class="item" v-for="(item, index) in nav">
				<template v-if="item.id ==='product'">
					<div class="menuTitle" :key="index" 
            @click.stop="switchMenuDown(index, item.id)" 
            :class="{on: activeNav==item.id || hoverMenu === item.id}"
            >
            {{navTitles[item.key]}}
          </div>
          <div class="menu-down" :key="`menuDown${index}`" 
            :class="{show: hoverMenu === item.id}" 
            :style="{left: (index)*110 + 'px' }"
            v-if="item.open || hoverMenu == item.id">
						<div v-for="(pItem, p) in cateLists" class="pItem" :key="`pItem${p}`">
							<div class="row typeTitle">
								<div v-if="pItem.templateId==3">{{pItem.title}}</div>
								<div v-else @click.stop="openPage(`/${item.id}/cate/${pItem.id}/${pItem.templateId}`)">{{pItem.title}}</div>
								<div v-if="['lg'].includes(deviceType)">
                  <i @click.stop="switchProduct(pItem, p)" class="el-icon-arrow-down" v-if="pItem.open"></i>
                  <i @click.stop="switchProduct(pItem, p)" class="el-icon-arrow-right" v-else></i>
                </div>
							</div>
							<div class="menuIII-box" v-show="pItem.productList.length && cate_opens[p]" v-for="(pItemII, pp) in pItem.productList" :key="pp">
								<div :to="{path: '/'+item.id, query: {id: pItemII.id, type: 'details'}}" :href="'./product?id='+pItemII.id + '&type=details'" @click.stop="openPage(`/${item.id}/details/${pItemII.id}/${pItemII.templateId}`)" class="row">
									{{pItemII.title}}
								</div>
							</div>
						</div>
					</div>
				</template>
        
				<template v-else-if="item.id ==='business'" :class="{on: activeNav==item.id || hoverMenu === item.id}">
					<div class="menuTitle" :key="index" 
          @click.stop="switchMenuDown(index, item.id)" @mouseover="menuMouseover(item.id)" @mouseout="menuMouseout(item.id)" 
          :class="{on: activeNav==item.id || hoverMenu === item.id}">{{navTitles[item.key]}}</div>
					<div class="menu-down" :key="`menuDown${index}`" 
            @mouseover="menuMouseover(item.id)" @mouseout="menuMouseout(item.id)" 
            :class="{show: hoverMenu === item.id }" 
            :style="{left: (index)*110 + 'px' }"
            v-if="item.open">
						<div :to="{path: '/'+item.id }" class="row" v-for="(menuII, n) in businessList" :key="n" @click.stop="openPage(`/${item.id}/${menuII.id}/${menuII.templateId}`)">{{menuII.title}}</div>
					</div>
				</template>
        <template v-else-if="item.id ==='new'" :class="{on: activeNav==item.id || hoverMenu === item.id}">
					<div class="menuTitle" :key="index" 
          @click.stop="switchMenuDown(index, item.id)" @mouseover="menuMouseover(item.id)" @mouseout="menuMouseout(item.id)" 
          :class="{on: activeNav==item.id || hoverMenu === item.id}">{{navTitles[item.key]}}</div>
					<div class="menu-down" :key="`menuDown${index}`" 
            @mouseover="menuMouseover(item.id)" @mouseout="menuMouseout(item.id)" :class="{show: hoverMenu === item.id }" 
            :style="{left: (index)*110 + 'px' }"
            v-if="item.open">
						<div :to="{path: '/'+item.id }" class="row" v-for="(newItem, n) in newMenuList" :key="n" @click.stop="openPage(`/${item.id}/${newItem.id}`)">{{newItem.title}}</div>
					</div>
				</template>
        <div :key="index" @click.stop="openPage(`/${item.id}`)" @mouseover="menuMouseover(item.id)" @mouseout="menuMouseout(item.id)" class="menuTitle" :class="{on: activeNav==item.id || hoverMenu === item.id}" v-else >
          <!-- <div :to="{path: '/'+item.id }" :href="'./'+item.id + ''" > -->
            {{navTitles[item.key]}}
          <!-- </div> -->
        </div>
			</template>
		</nav>
		<div class="burger" @click="switchMenu">
			<div class="burger-line1"></div>
			<div class="burger-line2"></div>
			<div class="burger-line3"></div>
		</div>
	</header>
</template>

<script>
	import logoImg from '@/assets/images2/header_logo@2x.png';
  import eventBus from '@/utils/eventBus';

	export default {
		path: '/'+'Header',
		props: {},
		data() {
			return {
				nav: [
					{
            id: 'index',
            key: 'key-menu-index-title',
						title: '首页2',
						type: '',
            url: '',
            open: false
					},
					{
            id: 'product',
            key: 'key-menu-product-title',
						title: '产品中心',
						type: '',
            url: '',
            open: false
					},
					{
            id: 'business',
            key: 'key-menu-business-title',
						title: '业务领域',
						type: '',
            url: '',
            open: false
					},
					{
						id: 'service',
            key: 'key-menu-service-title',
            title: '服务网络',
						type: '',
						url: '',
            open: false
					},
					{
						id: 'about',
            key: 'key-menu-about-title',
            title: '关于奔腾达',
						type: '',
						url: '',
            open: false
					},
					{
						id: 'new',
            key: 'key-menu-case-title',
            title: '新闻中心',
						type: '',
						url: '',
            open: false
					},
					{
						id: 'join',
            key: 'key-menu-join-title',
            title: '加入我们',
						type: '',
						url: '',
            open: false
					},
				],
				cateLists2: [
					{
						id: 1,
						titleType: '产品类型',
						title: '',
						productList: [
							{
								id: '1-1',
								title: '产品名称',
							},
							{
								id: '1-2',
								title: '产品名称',
							},
							{
								id: '1-3',
								title: '产品名称',
							}
						],
					},
					{
						id: '2',
						titleType: '',
						title: '产品名称',
					},
					{
						id: '3',
						titleType: '',
						title: '产品名称',
					},
					{
						id: '4',
						titleType: '产品类型',
						title: '',
						productList: [
							{
								id: '4-1',
								title: '产品名称',
							},
							{
								id: '4-2',
								title: '产品名称',
							},
							{
								id: '4-3',
								title: '产品名称',
							}
						],
					},
        ],
				showProduct: false,
				hoverMenu: '',
				openMenu: false,
        newMenuList: [
					{
            title: '行业资讯',
            id: 'consult',
            key: '',
					},
					{
						title: '企业动态',
            id: 'business',
            key: '',
					}
				],
				// activeNav: '',
        logoImg,
        clientWidth: '',
        cate_opens: []
			};
		},
		watch: {
      $route(to,from){
        console.log(from.path);//从哪来
        console.log(to.path);//到哪去
        this.hoverMenu = '';
        this.openMenu = false;
      },
			activeNav(val) {
        console.log('watch-- activeNav--val==', val);
        this.openMenu = false;
			}
		},
		computed: {
      deviceType() {
				return this.$store.state.deviceType;
      },
			navTitles() {
				return this.$store.state.navTitles;
      },
      activeNav() {
				return this.$store.state.activeNav;
      },
      cateLists() {
        const cateLists = this.$store.state.cateLists;
				return cateLists;
      },
      businessList() {
        return this.$store.state.businessList;
      }
		},
		created() {
      eventBus.$on('openMenu', value => {
        this.openMenu = value;
      })
      console.log('this.navTitles==', this.navTitles);
		},
		mounted() {},
    methods: {
      switchMenuDown(index, type) {
        console.log('switchMenuDown--index==', index);
        console.log('switchMenuDown--this.deviceType==', this.deviceType);
        if (!['lg'].includes(this.deviceType)) {
          this.cate_opens = [];
          const flag = this.deviceType == 'lg' ? false : true;
          this.cateLists.forEach(d => {
            this.cate_opens.push(flag)
          })
          console.log('header--this.cate_opens==', this.cate_opens);
          this.nav[index].open = !this.nav[index].open;
          if (type === 'product') {
            // let cateLists = JSON.parse(JSON.stringify(this.cateLists));
            // cateLists.forEach(d => {
            //   d.open = true;
            // })
            // this.$store.commit('cateLists', cateLists)
          }
          this.$set(this, 'cate_opens', this.cate_opens);
          this.$set(this, 'nav', this.nav);
          console.log('this.nav==', this.nav);
          
        }
      },
      openPage(url) {
        console.log('openPage--url==', url);
        
        let cur_route = this.$route.path
        if (cur_route == url) {
          return;
        }
        this.$router.push(url);
      },
			switchMenu() {
        this.nav.forEach(d => d.open = false)
				this.openMenu = !this.openMenu;
      },
      
			menuMouseover(menuId) {
        console.log('进入--menuMouseover--menuId==', menuId);
        
				if (!['lg'].includes(this.deviceType)) {
					return;
        }
        if (this.hoverMenu === menuId) {
        console.log('menuMouseover--menuId--2==', menuId);
          return
        }
        if (menuId === 'product') {
          this.cateLists.forEach(d => {
            d.open = false;
          });
        }
        
        this.hoverMenu = menuId;
        
			},
			menuMouseout(menuId) {
        console.log('离开--menuMouseout--menuId==', menuId);
        this.hoverMenu = ''
			},
			changeNav(item) {
				this.activeNav = item.id;
			},
			switchProduct(item, index) {
				console.log('switchProduct--item==', item);
				console.log('switchProduct--index==', index);
				console.log('switchProduct--this.cateLists==', this.cateLists);
				let row = JSON.parse(JSON.stringify(item));
				row.open = item.open ? false : true;
				this.$set(this.cateLists, index, row)
			},
		},
	}
</script>
<style scoped>
@import '../common/css/header2.scss';
</style>


// WEBPACK FOOTER //
// src/components/header2.vue